import createCache from '@emotion/cache'

/**
 * Creates an emotion cache for styling.
 *
 * @returns {object} An emotion cache with a specified key for managing CSS styles.
 */
export const createEmotionCache = () => {
    return createCache({ key: 'css' })
}
